import { createFileRoute } from "@tanstack/react-router";

import { AccountSettingsContainer } from "@/features/app-settings/containers/settings-container";

export const Route = createFileRoute("/app/settings/user/security")({
  component: AccountSettingsContainer,
});
